const $ = require('jquery');
window.$ = $;

const Core = require("./core").default;
window.Core = Core;

const Vue = require('vue').default;
const axios = require('axios').default;
let cancelTokenSource = axios.CancelToken.source();
let priceRequest;

import {isValidPhoneNumber} from 'libphonenumber-js'
import Notifications from "vt-notifications";
import Vuelidate from 'vuelidate'
import {email, minLength, maxLength, numeric, required} from 'vuelidate/lib/validators'

Vue.use(Notifications);
Vue.use(Vuelidate);
Vue.use(require('vue-cookies'))

const phoneNumber = function (value) {
  return isValidPhoneNumber(value, 'NL');
}

const postalCode = function (value) {
  value = value.split(' ').join('');
  let postcodeRegEx = /^[1-9][0-9]{3}[A-Z]{2}$/i;
  return postcodeRegEx.test(value);
}

window.Vue = Vue;

const defaultWindow = {
  id: null,
  type: 'window',
  width: 102,
  maxWidth: 200,
  minWidth: 20
};

const defaultTiltWindow = {
  id: null,
  type: 'tiltwindow',
  width: 75,
  maxWidth: 100,
  minWidth: 25
};

const defaultFixedWindow = {
  id: null,
  type: 'fixedwindow',
  width: 75,
  maxWidth: 100,
  minWidth: 25
};

const defaultPanel = {
  id: null,
  type: 'panel',
  width: 70,
  maxWidth: 642,
  minWidth: 10
};

const configurations = {
  200: [
    {...defaultTiltWindow},
    {...defaultWindow},
  ],
  250: [
    {...defaultTiltWindow},
    {...defaultWindow},
  ],
  300: [
    {...defaultTiltWindow},
    {...defaultWindow},
    {...defaultTiltWindow},
  ],
  350: [
    {...defaultTiltWindow},
    {...defaultWindow},
    {...defaultTiltWindow},
  ],
  400: [
    {...defaultTiltWindow},
    {...defaultWindow},
    {...defaultWindow},
    {...defaultTiltWindow},
  ],
  450: [
    {...defaultTiltWindow},
    {...defaultWindow},
    {...defaultTiltWindow},
    {...defaultPanel},
    {...defaultWindow},
    {...defaultTiltWindow},
  ],
  500: [
    {...defaultTiltWindow},
    {...defaultWindow},
    {...defaultTiltWindow},
    {...defaultPanel},
    {...defaultWindow},
    {...defaultTiltWindow},
  ],
  550: [
    {...defaultTiltWindow},
    {...defaultWindow},
    {...defaultTiltWindow},
    {...defaultPanel},
    {...defaultTiltWindow},
    {...defaultWindow},
    {...defaultTiltWindow},
  ],
  600: [
    {...defaultTiltWindow},
    {...defaultWindow},
    {...defaultTiltWindow},
    {...defaultPanel},
    {...defaultTiltWindow},
    {...defaultWindow},
    {...defaultTiltWindow},
  ],
  650: [
    {...defaultTiltWindow},
    {...defaultWindow},
    {...defaultPanel},
    {...defaultTiltWindow},
    {...defaultWindow},
    {...defaultPanel},
    {...defaultTiltWindow},
    {...defaultWindow},
  ],
  700: [
    {...defaultTiltWindow},
    {...defaultWindow},
    {...defaultPanel},
    {...defaultTiltWindow},
    {...defaultWindow},
    {...defaultPanel},
    {...defaultTiltWindow},
    {...defaultWindow},
    {...defaultTiltWindow},
  ],
}

const vueApp = new Vue({
  el: '#app',
  components: {
    'modal': () => import('./vue/Modal'),
    'popin': () => import('./vue/Popin'),
    'toast': () => import('./vue/Notification'),
    'dk-panel': () => import('./vue/DakkapelPanel'),
    'dk-tiltwindow': () => import('./vue/DakkapelTiltWindow'),
    'dk-fixed': () => import('./vue/DakkapelTiltWindow'),
    'dk-window': () => import('./vue/DakkapelWindow'),
    'dk-preview-element': () => import('./vue/DakkapelPreviewElement'),
    'dk-element': () => import('./vue/DakkapelElement'),
  },
  validations: {
    quoteForm: {
      first_name: {
        required,
        minLength: minLength(2)
      },
      last_name: {
        required,
        minLength: minLength(2)
      },
      email: {
        required,
        email
      },
      phone: {
        required,
        phoneNumber
      },
      postal: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(7),
        postalCode
      },
      city: {}, // from api
      street: {}, // from api
      house_number: {
        required,
        numeric,
        minLength: minLength(1)
      },
      house_number_addition: {},
      terms: {
        required
      },
      remarks: {}
    }
  },
  data: {
    showLandscapeNotification: false,
    showUpgradeBrowser: false,
    sent: false,
    submitting: false,
    quoteErrors: [],
    quoteForm: {
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      postal: '',
      street: '',
      city: '',
      house_number: '',
      house_number_addition: '',
      remarks: '',
      terms: false,
    },
    geoCodeFeedback: '',
    popin: {
      show: false,
      title: '',
      subtitle: '',
      content: '',
    },
    lastNotifications: [],
    showModal: false,
    // mode: 'default',
    mode_step3: 'default',
    mode_step4: 'default',
    mode_step5: 'default',
    intervalTimer: 100,
    qty: 2, // elementen
    elements: [
      {...defaultTiltWindow, ...{id: 1}, key: window.Core.uniqid()},
      {...defaultWindow, ...{id: 2}, key: window.Core.uniqid()},
      {...defaultTiltWindow, ...{id: 3}, key: window.Core.uniqid()},
      {...defaultWindow, ...{id: 4}, key: window.Core.uniqid()},
      {...defaultTiltWindow, ...{id: 5}, key: window.Core.uniqid()},
      {...defaultWindow, ...{id: 6}, key: window.Core.uniqid()},
      {...defaultTiltWindow, ...{id: 7}, key: window.Core.uniqid()},
      {...defaultWindow, ...{id: 8}, key: window.Core.uniqid()},
      {...defaultTiltWindow, ...{id: 9}, key: window.Core.uniqid()},
      {...defaultWindow, ...{id: 10, key: window.Core.uniqid()}},
      {...defaultTiltWindow, ...{id: 11, key: window.Core.uniqid()}},
      {...defaultWindow, ...{id: 12, key: window.Core.uniqid()}},
      {...defaultTiltWindow, ...{id: 13, key: window.Core.uniqid()}},
      {...defaultWindow, ...{id: 14, key: window.Core.uniqid()}},
    ],
    colours: [],
    // elementtypes: [],
    widthSides: 58, // to subtract from the outer width, gives inner available canvas
    scaleFactor: 5,
    canvasScale: 0.25,
    maxWidth: 700,
    minWidth: 200,
    maxHeight: 175,
    minHeight: 100,
    width: 200,
    height: 150,
    elementStep: 5,
    frame: null,
    woods: [],
    material: null,
    rooftrim: null,
    rooftrimColour: null,
    rooftype: null,
    roofconnection: '1',
    dormerColour: null,
    buoyColour: null,
    windowFrameColour: null,
    tiltWindowFrameColour: null,
    fixedWindowFrameColour: null,
    minirooftop: false,
    hiddengutters: false,
    ventilationgrilles: 0,
    sunbarrier: false,
    removalcoarsedirt: false,
    insectscreens: 0,
    permit: false,
    price: '',
    blockDom: false,
    loading: true,
    conversionUrl: '',
  },

  computed: {
    minirooftopChosen: function () {
      return this.minirooftop && this.minirooftop !== 'false';
    },
    materialTitle: function () {
      let temp = this.material; // we need to reference this property here, otherwise the computed property is not updated on change
      let target = document.getElementById('dakkapel-material');

      if (target.options.selectedIndex > -1) {
        let found = document.querySelector('#dakkapel-material option[value="' + temp + '"]');
        if (found) {
          return found.dataset.friendly
        }
      }

      return this.material;
    },
    isWood: function () {
      return (this.woods.includes(parseInt(this.material)))
    },
    leftWidth: function () {
      let base = 16
      let width = base;
      let firstElement = null;
      if (this.activeElements.length > 0) {
        firstElement = this.activeElements.slice(0, 1)[0]
        if (firstElement.type === 'panel') {
          width = base + firstElement.width;
        }
      }
      // console.log(firstElement)
      return width;
    },
    rightWidth: function () {
      let base = 16
      let width = base;
      let firstElement = null;
      if (this.activeElements.length > 1) {
        firstElement = this.activeElements.slice(-1)[0]
        if (firstElement.type === 'panel') {
          width = base + firstElement.width;
        }
      }
      return width;
    },
    // a computed getter
    canvasHeight: function () {
      return ((this.height - 15) * this.scaleFactor);
    },
    canvasWidth: function () {
      return this.width * this.scaleFactor;
    },
    // previewWidth: function () {
    //   let scale = this.maxWidth - this.minWidth;
    //   let compensatedzero = this.width - this.minWidth;
    //   let relative = compensatedzero / scale;
    //   //let percentage = Math.round(relative * 100);
    //   let canvasMinWidth = 50;
    //   let canvasMaxWidth = 98;
    //   let canvasScale = canvasMaxWidth - canvasMinWidth; // 40
    //   let add = (relative * canvasScale) + canvasMinWidth;
    //   let canvasWidth = Math.round(add);
    //   return canvasWidth;
    // },
    // previewHeight: function () {
    //   return this.height;
    // },
    activeElements: function () {
      return this.elements.slice(0, this.qty);
    },
    nonTilts: function () {
      return this.activeElements.filter(function (value) {
        return (value.type === 'window' || value.type === 'fixedwindow');
      });
    },
    numNonTilts: function () {
      return this.nonTilts.length;
    },
    windows: function () {
      return this.activeElements.filter(function (value) {
        return (value.type === 'window');
      });
    },
    numWindows: function () {
      return this.windows.length;
    },
    tiltWindows: function () {
      return this.activeElements.filter(function (value) {
        return (value.type === 'tiltwindow');
      });
    },
    numTiltWindows: function () {
      return this.tiltWindows.length;
    },
    fixedWindows: function () {
      return this.activeElements.filter(function (value) {
        return (value.type === 'fixedwindow');
      });
    },
    numFixedWindows: function () {
      return this.fixedWindows.length;
    },
    panels: function () {
      return this.activeElements.filter(function (value) {
        return (value.type === 'panel');
      });
    },
    numPanels: function () {
      return this.panels.length;
    },
    numAllWindows: function () {
      return this.numWindows + this.numTiltWindows + this.numFixedWindows;
    },
    lastElement: function () {
      const [lastItem] = this.elements.slice(this.qty - 1, this.qty)
      return lastItem;
    },
    elementsWidth: function () {
      const lastItem = this.lastElement
      if (lastItem) {
        let self = this;
        let elementsWidth = 0;
        this.activeElements.slice(0, this.qty).forEach(function (element, index) {
          elementsWidth += element.width;
        });
        return elementsWidth;
      }
      return 0;
    },
    minElementsWidth: function () {
      return this.calcMinElementsWidth(this.qty)
    },
    maxElementsWidth: function () {
      return this.calcMaxElementsWidth(this.qty)
    },
    innerWidth: function () {
      return this.width - this.widthSides;
    }
  },
  watch: {
    'popin.show': function (newValue, oldValue) {
      if (newValue === true) {
        document.body.classList.add('overflow-hidden')
      } else {
        document.body.classList.remove('overflow-hidden')
      }
    },
    dormerColour: function (newValue, oldValue) {
      if (this.mode_step4 === 'default') {
        // buoyColour is invisible in default mode, change too
        this.buoyColour = newValue;
      }
      this.onAfterChange()
    },
    buoyColour: function (newValue, oldValue) {
      this.onAfterChange()
    },
    windowFrameColour: function (newValue, oldValue) {
      if (this.mode_step4 === 'default') {
        // tiltWindowFrameColour is invisible in default mode, change too
        this.tiltWindowFrameColour = newValue;
      }
      this.onAfterChange()
    },
    tiltWindowFrameColour: function (newValue, oldValue) {
      this.onAfterChange()
    },

    material: function (newValue, oldValue) {
      let self = this
      let filteredColours = this.colours.filter(function (colour) {
        return colour.for.includes(parseInt(self.material))
      })

      if (!this.colorAvailable(filteredColours, this.dormerColour)) {
        this.dormerColour = filteredColours[0].color;
      }

      if (!this.colorAvailable(filteredColours, this.buoyColour)) {
        this.buoyColour = filteredColours[0].color;
      }

      let filteredFrameColours = this.colours.filter(function (colour) {
        return colour.forFrames.includes(parseInt(self.material))
      })

      if (!this.frameColorAvailable(filteredFrameColours, this.windowFrameColour)) {
        this.windowFrameColour = filteredFrameColours[0].color;
      }

      if (!this.frameColorAvailable(filteredFrameColours, this.tiltWindowFrameColour)) {
        this.tiltWindowFrameColour = filteredFrameColours[0].color;
      }

      if (!this.colorAvailable(filteredColours, this.rooftrimColour)) {
        this.rooftrimColour = filteredColours[0].color;
      }

    },
    width: function () {
      this.updateWidth();
      this.handleResize();
    },
    height: function () {
      this.handleResize();
    },

    qty: function (newValue, oldValue) {
      this.makeElementsEven();
    },

    'quoteForm.postal': function (newValue, oldValue) {
      this.quoteForm.postal = this.quoteForm.postal.split(' ').join('');
      this.fillAddress()
    },

    'quoteForm.house_number': function (newValue, oldValue) {
      this.fillAddress()
    },

    'quoteForm.house_number_addition': function (newValue, oldValue) {
      this.fillAddress()
    }
  },
  methods: {
    fillAddress: function () {
      if (this.$v.quoteForm.postal.$invalid || this.$v.quoteForm.house_number.$invalid) {
        this.geoCodeFeedback = '';
        this.quoteForm.city = '';
        this.quoteForm.street = '';
      }
      if (!this.$v.quoteForm.postal.$invalid && !this.$v.quoteForm.house_number.$invalid) {
        return this.getStreetAddressFrom(
          this.$v.quoteForm.postal.$model,
          this.$v.quoteForm.house_number.$model,
          this.$v.quoteForm.house_number_addition.$model
        ).then(response => {
          if (response.data.success === false) {
            this.quoteForm.city = '';
            this.quoteForm.street = '';
            this.geoCodeFeedback = 'Geen resultaten voor postcode/huisnummer.';
          } else if (response.data.success === true) {
            this.geoCodeFeedback = '';
            this.quoteForm.city = response.data.city ?? '';
            this.quoteForm.street = response.data.street ?? '';
          }
        }).catch(error => {
          this.quoteForm.city = '';
          this.quoteForm.street = '';
          this.geoCodeFeedback = 'Geen resultaten voor postcode/huisnummer.';
        })
      }
    },

    async getStreetAddressFrom(postal, houseNumber, addition) {
      let postParams = new FormData();
      postParams.append('postal', postal);
      postParams.append('houseNumber', houseNumber);
      postParams.append('addition', addition);
      return await axios.post("/api/getAddress/", postParams);
    },
    dismissLandscapeNotification: function () {
      this.$cookies.set('landscapeDismissed', true);
      this.showLandscapeNotification = false;
    },
    requestQuote: function () {
      let self = this
      self.blockDom = true;
      this.poll(true).then(function () {
        self.blockDom = false;
        self.showModal = true
      })
    },
    makeElementsEven: function () {
      let self = this;
      // console.log('makeElementsEven')

      let desiredWidthTilts = 75;
      let desiredWidthPanels = 20;

      let tiltWindows = [...this.tiltWindows];
      let panels = [...this.panels];

      let currentWidth = 0;

      tiltWindows.forEach(function (element, index) {
        element.width = desiredWidthTilts
        currentWidth += element.width;
      });

      panels.forEach(function (element, index) {
        element.width = desiredWidthPanels
        currentWidth += element.width;
      });

      let needsFitting = false;
      let difference = this.innerWidth - currentWidth
      let nonTilts = [...this.nonTilts];

      nonTilts.forEach(function (element, index) {
        let desiredWidth = Math.floor(difference / self.numNonTilts)
        if (desiredWidth >= element.minWidth && desiredWidth <= element.maxWidth) {
          element.width = desiredWidth
        } else {
          needsFitting = true;
        }
      });

      // console.log(needsFitting);

      if (needsFitting) {
        needsFitting = false;
        nonTilts.forEach(function (element, index) {
          self.fitOtherElements(element)
        });

        difference = this.innerWidth - this.elementsWidth;
        if (difference > 0) {
          tiltWindows.forEach(function (element, index) {
            self.fitOtherElements(element)
          });
        }

      } else {
        this.fitLastElement();
      }

      this.updatePrice()
    },

    calcMaxElementsWidth: function (useNumber) {
      const lastItem = this.lastElement
      // console.log(useNumber)
      if (lastItem) {
        let self = this;
        let maxElementsWidth = 0;
        this.elements.slice(0, useNumber).forEach(function (element, index) {
          maxElementsWidth += element.maxWidth;
        });
        // console.log('max ', maxElementsWidth);
        return maxElementsWidth;
      }
      return 0;
    },
    calcMinElementsWidth: function (useNumber) {
      // console.log(useNumber);
      const lastItem = this.lastElement
      if (lastItem) {
        let self = this;
        let minElementsWidth = 0;
        this.elements.slice(0, useNumber).forEach(function (element, index) {
          minElementsWidth += element.minWidth;
        });
        // console.log('min ', minElementsWidth);
        return minElementsWidth;
      }
      return 0;
    },
    colorAvailable: function (colours, current) {
      // get id first
      let colourWithSameCode = colours.filter(function (colour) {
        return colour.color === current
      })

      if (colourWithSameCode.length > 0) {
        let colourID = colourWithSameCode[0]
        return colours.filter(function (colour) {
          return colour.for.includes(parseInt(colourID))
        })
      }
      return false;
    },
    frameColorAvailable: function (colours, current) {
      // get id first
      let colourWithSameCode = colours.filter(function (colour) {
        return colour.color === current
      })

      if (colourWithSameCode.length > 0) {
        let colourID = colourWithSameCode[0]
        return colours.filter(function (colour) {
          return colour.forFrames.includes(parseInt(colourID))
        })
      }
      return false;
    },
    size: function (px) {
      return px / 2 + 'px';
    },
    shouldBeHiddenElement: function (element, index) {
      if (element.type === 'panel' && this.activeElements.length === (index + 1)) {
        return true;
      }

      if (element.type === 'panel' && index === 0) {
        return true;
      }

      return false;
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    getElementByIndex: function (index) {
      const item = this.elements[index]
      return item;
    },
    getIndexFromElement: function (findElement) {
      let indexFound = 0;
      this.elements.forEach(function (element, index) {
        if (findElement.id === element.id) {
          indexFound = index;
        }
      });
      return indexFound;
    },
    getLastElement: function () {
      const [lastItem] = this.elements.slice(this.qty - 1, this.qty)
      return lastItem;
    },
    getBeforeLastElement: function () {
      if (this.qty > 1) {
        const [beforeLastItem] = this.elements.slice(this.qty - 2, this.qty - 1)
        return beforeLastItem;
      }
      return null;
    },
    onAfterChange: function (element) {
      this.fitElements(element)
      this.updatePrice()
    },
    onAfterChangeDimensions: function (element) {
      this.makeElementsEven(element)
      this.updatePrice()
    },

    updatePrice: function () {
      if (this.priceTimeout) {
        clearTimeout(this.priceTimeout);
      }
      this.priceTimeout = setTimeout(() => this.poll(), 250)
    },

    getConfiguration: function () {
      let config = this.$data ?? {};
      let formData = Core.getFormDataFromArray(config)
      return formData;
    },

    closePopin: function () {
      this.popin.show = false
      this.popin.title = ''
      this.popin.subtitle = ''
      this.popin.content = ''
    },

    showPopin: function (urlSegment) {
      this.loading = true;
      priceRequest = axios
        .get('/api/getInfo/', {
          params: {
            url_segment: urlSegment
          },
          cancelToken: cancelTokenSource.token,
        })
        .then(response => {
          if (response.data.popin) {
            this.popin.show = true
            this.popin.title = response.data.popin.title
            this.popin.subtitle = response.data.popin.subtitle
            this.popin.content = response.data.popin.content
          }
        })
        .catch(error => {
          if (error instanceof axios.Cancel) {
            //console.log('cancel:', error.message)
          } else {
            if (typeof error.response.data.errors === 'object') {
              error.response.data.errors.forEach(function (errorMessage, index) {
                self.$notify(
                  {
                    group: "default",
                    title: "Fout opgetreden",
                    text: errorMessage,
                    type: 'error'
                  },
                  5000
                );
              })
            }
            this.errored = true
          }
        })
        .then(() => {
          this.loading = false
        })
    },

    poll: function (force) {
      let self = this
      let postParams = this.getConfiguration();

      if (force) {
        postParams.append('forceUpdate', true)
      }

      if (typeof cancelTokenSource !== undefined) {
        cancelTokenSource.cancel("Newer request received.");
      }

      cancelTokenSource = axios.CancelToken.source();

      this.loading = true;
      priceRequest = axios
        .post('/api/getPrices/', postParams, {
          cancelToken: cancelTokenSource.token,
        })
        .then(response => {
          if (response.data.price) {
            this.price = response.data.price
          }
          // for (const [key, element] of Object.entries(response.data.configuration)) {
          //   this[key] = element
          // }

        })
        .catch(error => {
          if (error instanceof axios.Cancel) {
            //console.log('cancel:', error.message)
          } else {
            if (typeof error.response.data.errors === 'object') {
              error.response.data.errors.forEach(function (errorMessage, index) {
                self.$notify(
                  {
                    group: "default",
                    title: "Fout opgetreden",
                    text: errorMessage,
                    type: 'error'
                  },
                  5000
                );
              })
            }
            this.errored = true
          }
        })
        .then(() => {
          this.loading = false
        })
      return priceRequest
    },

    checkQuoteForm: function () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$notify(
          {
            group: "default",
            title: "Formulier bevat fouten",
            text: "Controleer de velden en probeer het opnieuw",
            type: 'error'
          },
          5000
        );
      } else {
        this.sendQuoteForm();
      }
    },

    sendQuoteForm: function () {
      this.submitting = true;
      let self = this;
      let config = this.$data ?? {};
      let formData = Core.getFormDataFromArray(config)

      axios.post('/api/requestQuote', formData)
        .then(response => {
          if (response.data.success) {
            this.sent = true;
            self.$notify(
              {
                group: "default",
                title: "Offerte-aanvraag verzonden!",
                text: "We hebben je aanvraag ontvangen.",
                type: 'info'
              },
              5000
            );

            window.location = this.conversionUrl;

          } else {
            self.$notify(
              {
                group: "default",
                title: "Er ging iets fout",
                text: "Probeer het nog eens",
                type: 'error'
              },
              5000
            );
          }
        })
        .catch((error) => {
          if (typeof error.response.data.errors === 'object') {
            error.response.data.errors.forEach(function (errorMessage, index) {
              self.$notify(
                {
                  group: "default",
                  title: "Fout opgetreden",
                  text: errorMessage,
                  type: 'error'
                },
                5000
              );
            })
          }
        }).finally(() => {
        this.submitting = false;
      });
    },

    onAfterAddElement: function (elementIndex) {
      const lastItem = this.getElementByIndex(elementIndex)
      this.fitPreviousElements(lastItem);
    },
    onAfterRemoveElement: function () {
      // console.log('onAfterRemoveElement')
      this.fitLastElement()
    },
    fitElements: function (element) {
      if (element) {
        this.fitOtherElements(element)
      } else {
        this.fitLastElement()
      }
    },
    fitOtherElements: function (currentElement) {
      let difference = this.elementsWidth - this.innerWidth
      let direction = difference < 0 ? 'grow' : 'shrink'

      let self = this;
      let reversedElements = [...this.activeElements].reverse(); // do not mutate the original array

      // check if previous last element can be shrunk
      reversedElements.forEach(function (element, index) {
        if (element.id !== currentElement.id && difference !== 0) {
          let canBeShrunk = element.width - element.minWidth;
          let canBeAdded = element.maxWidth - element.width;

          if (difference < 0 && direction === "grow") {
            let add = Math.min(Math.abs(difference), canBeAdded);
            // console.log('canBeAdded', canBeAdded, add)
            element.width = element.width + add;
            difference += add;
          } else if (difference > 0 && direction === "shrink") {
            let shrink = Math.min(Math.abs(difference), canBeShrunk);
            // console.log('canBeShrunk', canBeShrunk, 'subtract', shrink)
            element.width = element.width - shrink;
            difference -= shrink;
            // console.log('diff now', difference)
          }
        }
      });

      if (difference > 0) {
        // could not shrink other elements anymore
        let newProposedWidth = currentElement.width - difference;
        if (newProposedWidth >= currentElement.minWidth) {
          currentElement.width = newProposedWidth;
        }
        this.fitElement(currentElement)
      }
    },

    removeNotificationFromList: function (identifier) {
      let position = this.lastNotifications.indexOf(identifier)
      if (position !== -1) {
        this.lastNotifications.splice(position, 1)
      }
    },

    addNotification: function (identifier, notification) {
      let self = this
      if (!this.lastNotifications.includes(identifier)) {
        this.lastNotifications.push(identifier)
        this.$notify(notification, 5000)
        window.setTimeout(function () {
          self.removeNotificationFromList(identifier)
        }, 5000)
      }
    },

    notifyTooSmall: function (n) {
      this.addNotification('toosmall' + n, {
        group: "default",
        title: "Je dakkapel is te klein",
        text: "Maak de dakkapel breder of kies andere elementen, als je " + n + " " + (n === 1 ? 'element' : 'elementen') + " wilt",
        type: 'error'
      })
    },

    notifyTooBig: function (n) {
      this.addNotification('toobig' + n, {
        group: "default",
        title: "Je dakkapel is te groot",
        text: "Maak de dakkapel smaller of kies andere elementen, als je " + n + " " + (n === 1 ? 'element' : 'elementen') + " wilt",
        type: 'error'
      })
    },

    adjustQty: function (n) {
      let inner = this.innerWidth
      let min = this.calcMinElementsWidth(n)
      let max = this.calcMaxElementsWidth(n)

      if (this.innerWidth < min) {
        this.notifyTooSmall(n)
      } else if (this.innerWidth > max) {
        this.notifyTooBig(n)
      } else {
        this.qty = n
      }
    },

    fitLastElement: function () {
      const lastItem = this.getLastElement()
      if (lastItem) {
        if (this.elementsWidth < this.innerWidth) {
          // console.log('elements too wide')
          let restSpace = this.innerWidth - this.elementsWidth;

          if (lastItem.maxWidth > lastItem.width) {
            lastItem.width = lastItem.width + restSpace;
            this.fitElement(lastItem)
          } else {
            this.fitOtherElements(lastItem)
          }

          if (this.innerWidth > this.maxElementsWidth) {
            // add element
            this.qty += 1
            this.$nextTick()
          }

        } else if (this.elementsWidth > this.innerWidth) {
          // console.log('elements too small')
          let overflow = this.elementsWidth - this.innerWidth;
          if (lastItem.minWidth < lastItem.width) {
            lastItem.width = lastItem.width - overflow;
            this.fitElement(lastItem)
          } else {
            this.fitOtherElements(lastItem)
          }
        }
      }
    },
    fitPreviousElements: function (currentElement) {
      let self = this
      // console.log('fit previous elements')

      currentElement = this.fitElement(currentElement)
      let needsToAdd = currentElement.width;
      let elementIndex = this.getIndexFromElement(currentElement);
      // console.log('we need at least', needsToAdd)

      // check if previous last element can be shrunk
      const reversedElements = this.activeElements.slice(0, elementIndex).reverse();
      reversedElements.forEach(function (element, index) {
        let canBeShrunk = element.width - element.minWidth;
        if (canBeShrunk > 0) {
          if (needsToAdd > 0) {
            let shrink = Math.min(needsToAdd, canBeShrunk);
            element.width = element.width - shrink;
            needsToAdd -= shrink;
          } else {
            // console.log('done shrinking')
          }

          element = self.fitElement(element)
        } else {
          // console.log('cannot shrink 2')
        }
      });
    },

    fitElement: function (element) {
      if (element.width > element.maxWidth) {
        element.width = element.maxWidth;
      } else if (element.width < element.minWidth) {
        element.width = element.minWidth;
      }
      if (element.width > this.innerWidth) {
        element.width = this.innerWidth;
      }
      return element
    },

    onAfterChangeElement: function (element) {
      if (element.width > element.maxWidth) {
        element.width = element.maxWidth;
      } else if (element.width < element.minWidth) {
        element.width = element.minWidth;
      }
      this.onAfterChange(element);
    },
    setToTiltwindow: function (element) {
      element.type = 'tiltwindow'
      element.maxWidth = defaultTiltWindow.maxWidth
      element.minWidth = defaultTiltWindow.minWidth
      this.onAfterChangeElement(element)
    },
    setToFixedwindow: function (element) {
      element.type = 'fixedwindow'
      element.maxWidth = defaultFixedWindow.maxWidth
      element.minWidth = defaultFixedWindow.minWidth
      this.onAfterChangeElement(element)
    },
    setToWindow: function (element) {
      element.type = 'window'
      element.maxWidth = defaultWindow.maxWidth
      element.minWidth = defaultWindow.minWidth
      this.onAfterChangeElement(element)
    },
    setToPanel: function (element) {
      element.type = 'panel'
      element.maxWidth = defaultPanel.maxWidth
      element.minWidth = defaultPanel.minWidth
      this.onAfterChangeElement(element)
    },
    incrementElementWidth: function (element) {
      if (element.width <= (element.maxWidth - this.elementStep)) {
        element.width = element.width + this.elementStep;
      } else if (element.width <= (element.maxWidth - 1)) {
        element.width = element.width + 1;
      }
      element = this.fitElement(element)
      this.onAfterChangeElement(element)
    },
    decrementElementWidth: function (element) {
      if (element.width >= (element.minWidth + this.elementStep)) {
        element.width = element.width - this.elementStep;
      } else if (element.width >= (element.minWidth + 1)) {
        element.width = element.width - 1;
      }
      element = this.fitElement(element)
      this.onAfterChangeElement(element)
    },

    makeDesiredConfiguration: function () {
      // console.log(configurations)
      let self = this
      // this.width

      let chosen = null
      for (const [breakpoint, configuration] of Object.entries(configurations)) {
        if (self.width >= breakpoint) {
          chosen = configuration
        }
      }

      if (chosen) {
        self.adjustQty(chosen.length)

        let index = 0;
        chosen.forEach(function (defaultElement, breakpoint) {
          self.elements[index].type = defaultElement.type
          self.elements[index].minWidth = defaultElement.minWidth
          self.elements[index].maxWidth = defaultElement.maxWidth
          self.elements[index].width = defaultElement.width
          self.elements[index].key = window.Core.uniqid(defaultElement.type, true) // trigger re-render of element
          index++
        })
      }
    },
    updateWidth: function () {
      if (this.width > this.maxWidth) {
        this.width = this.maxWidth;
      }
      if (this.width < this.minWidth) {
        this.width = this.minWidth;
      }

      this.makeDesiredConfiguration()
      this.onAfterChangeDimensions();
    },

    handleResize: function () {
      let safeX = 20;
      let appWidth = Math.floor(this.$refs.canvas.clientWidth) - safeX;
      let appWidthEven = 2 * Math.round(appWidth / 2);

      let safeY = 20;
      if (this.minirooftopChosen) {
        safeY += 35;
        if (this.width < 330 && this.$refs.canvas.clientHeight > 300) {
          safeY += 65;
        }
      }

      let appHeight = Math.floor(this.$refs.canvas.clientHeight) - safeY;
      let appHeightEven = 2 * Math.round(appHeight / 2);

      let scaleX = appWidthEven / (this.width) / this.scaleFactor;
      let scaleY = appHeightEven / (this.height) / this.scaleFactor;

      this.canvasScale = Math.min(Math.round(scaleX * 100) / 100, Math.round(scaleY * 100) / 100);
      this.onAfterChangeDimensions();
    },
    decrementWidth: function () {
      if (this.width > this.minWidth) {
        this.width = parseInt(this.width) - 5;
      }
      this.onAfterChangeDimensions();
    },
    incrementWidth: function () {
      if (this.width < this.maxWidth) {
        this.width = parseInt(this.width) + 5;
      }
      // console.log('incrementWidth')
      this.onAfterChangeDimensions();
    },
    startIncrementWidth() {
      this.loops = this.loops ?? 0
      this.speed = this.startedInterval ? 10 : this.intervalTimer;
      let self = this;

      this.interval = setTimeout(function () {
        if (self.loops > 2) {
          self.startedInterval = true
        }
        self.loops++;
        self.incrementWidth()
        self.interval = setTimeout(self.startIncrementWidth, self.speed)
      }, this.speed)
    },
    stopIncrementWidth() {
      clearTimeout(this.interval)
      this.loops = 0
      this.startedInterval = false
    },
    startDecrementWidth() {
      this.loops = this.loops ?? 0
      this.speed = this.startedInterval ? 10 : this.intervalTimer;
      let self = this;

      this.interval = setTimeout(function () {
        if (self.loops > 2) {
          self.startedInterval = true
        }
        self.loops++;
        self.decrementWidth()
        self.interval = setTimeout(self.startDecrementWidth, self.speed)
      }, this.speed)
    },
    stopDecrementWidth() {
      clearTimeout(this.interval)
      this.loops = 0
      this.startedInterval = false
    },
    decrementHeight: function () {
      if (this.height > this.minHeight) {
        this.height = parseInt(this.height) - 5;
      }
      // console.log('decrementHeight')
      this.onAfterChangeDimensions();
    },
    incrementHeight: function () {
      if (this.height < this.maxHeight) {
        this.height = parseInt(this.height) + 5;
      }
      // console.log('incrementHeight')
      this.onAfterChangeDimensions();
    }
  },
  mounted: function () {
    this.conversionUrl = this.$el.getAttribute('data-thanks-url');
    this.woods = JSON.parse(this.$el.getAttribute('data-wood-materials'));
    this.material = this.$el.getAttribute('data-material');
    this.frame = this.$el.getAttribute('data-frame');
    this.rooftrim = this.$el.getAttribute('data-rooftrim');
    this.rooftrimColour = this.$el.getAttribute('data-rooftrim-colour');
    this.buoyColour = this.$el.getAttribute('data-buoy-colour');
    this.dormerColour = this.$el.getAttribute('data-dormer-colour');
    this.windowFrameColour = this.$el.getAttribute('data-window-colour');
    this.tiltWindowFrameColour = this.$el.getAttribute('data-tiltwindow-colour');
    this.fixedWindowFrameColour = this.$el.getAttribute('data-tiltwindow-colour');
    this.rooftype = this.$el.getAttribute('data-rooftype');

    this.colours = JSON.parse(this.$el.getAttribute('data-colours'));
    // this.elementtypes = JSON.parse(this.$el.getAttribute('data-elementtypes'));

    if (this.$el.getAttribute('data-width')) {
      this.width = this.$el.getAttribute('data-width')
    }

    if (this.$el.getAttribute('data-height')) {
      this.height = this.$el.getAttribute('data-height')
    }

    this.handleResize();
    window.document.onreadystatechange = () => {
      if (document.readyState === "complete") {
        // console.log('completed');
        vueApp.handleResize();
        $('#dakkapelCanvas').removeClass('opacity-0')
      }
    }
  },
  created() {
    // console.log('created');
    window.addEventListener('resize', this.handleResize);

    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closePopin();
      }
    });

    this.showLandscapeNotification = !this.$cookies.get('landscapeDismissed');

  },
  destroyed() {
    // console.log('destroyed');
    window.removeEventListener('resize', this.handleResize);
  },
})
